import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { CheckVersionService } from '@okcargo-apps/shared-infrastructure';

@Component({
  selector: 'lib-help-contact',
  templateUrl: './help-contact.component.html',
  styleUrls: ['./help-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, IonIcon, TranslateModule],
})
export class HelpContactComponent {
  private readonly checkVersionService = inject(CheckVersionService);

  public appVersionInfo = this.checkVersionService.localAppInfo;
}
